import { connect } from 'react-redux'

import { ShowerIcon } from 'components/icons'
import { getShowerInfo } from 'registry/reducers'

import SetupGoal from './setup-goal'
import * as EventPresenters from 'registry/presenters/event-presenter'

function mapStateToProps(state, ownProps) {
  return {
    ...ownProps,
    icon: <ShowerIcon />,
    text: EventPresenters.getCopy(getShowerInfo(state)),
  }
}

export default connect(mapStateToProps)(SetupGoal)
